// Instanciation paresseuse des blocs AdSense.
//
// Les macros `partials/ads.twig` posent les <ins> sans `push()` inline. C'est ce module qui
// les active quand ils approchent de l'écran :
//  - plusieurs push() au chargement dégradent l'INP (métrique Core Web Vitals) ;
//  - le HTML des fenêtres de détail est injecté via innerHTML, où un <script> inline n'est
//    jamais exécuté : ces blocs n'étaient tout simplement jamais initialisés.
//
// Piège central : `adsbygoogle.push({})` ne remplit PAS le <ins> qu'on croit désigner — le
// loader prend le premier <ins.adsbygoogle> non encore initialisé dans l'ordre du DOM. Si on
// pousse pour le 3ᵉ bloc alors que les deux premiers ne l'ont pas été, c'est le 1ᵉʳ qui est
// rempli, avec un format prévu pour un autre emplacement. D'où `fillUpTo()`, qui initialise
// aussi tout ce qui précède la cible.

const ROOT_MARGIN = '200px'
const observed = new WeakSet()
let observer = null

function push(ins) {
  ins.dataset.cmPushed = '1'
  try {
    ;(window.adsbygoogle = window.adsbygoogle || []).push({})
  } catch (e) {
    /* script AdSense bloqué : rien à faire */
  }
}

function fillUpTo(target) {
  const list = Array.from(document.querySelectorAll('ins.adsbygoogle'))
  const end = list.indexOf(target)
  if (end < 0) return

  for (let i = 0; i <= end; i++) {
    const ins = list[i]
    if (ins.dataset.cmPushed || ins.dataset.adsbygoogleStatus) continue
    push(ins)
  }
}

function getObserver() {
  if (observer) return observer
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        observer.unobserve(entry.target)
        fillUpTo(entry.target)
      })
    },
    { rootMargin: ROOT_MARGIN },
  )
  return observer
}

/** Prend en charge les <ins> présents sous `root` (document, ou fragment fraîchement injecté). */
export function scanAds(root = document) {
  const list = root.querySelectorAll ? root.querySelectorAll('ins.adsbygoogle') : []
  if (!list.length) return

  // Sans IntersectionObserver (navigateurs anciens), on initialise tout de suite : mieux vaut
  // une pub servie qu'un emplacement vide.
  if (typeof IntersectionObserver === 'undefined') {
    list.forEach((ins) => {
      if (!ins.dataset.cmPushed) push(ins)
    })
    return
  }

  const obs = getObserver()
  list.forEach((ins) => {
    if (observed.has(ins) || ins.dataset.cmPushed) return
    observed.add(ins)
    obs.observe(ins)
  })
}

export function initAds() {
  scanAds(document)

  // Contenu ajouté après coup (fenêtres de détail de la carte).
  document.addEventListener('cm:contentadded', (e) => scanAds(e.detail?.root || document))
}
